import React, { Component } from 'react';
import brandLogo from '../images/brand-logo-inverse-dark.png';
import { GENDER } from './OnboardingContainer.js';
import { Trans, translate } from 'react-i18next';
import { LANG } from '../App.js';

class Profile extends Component {
  
  render() {
    const { t } = this.props;
    return (
      <div className="login-panel panel panel-default">
        <div className="panel-content">
          <div className="panel-heading-signup text-center">
            <img height="50px" alt="IOS OFFICES" src={brandLogo} />
          </div>
          <div className="panel-body-singup">
            <h4>{t('onboarding.profile.heading')}</h4>
            <form method="post" onSubmit={this.props.handleProfileSubmit}>
              <fieldset>
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleNameChange}
                    placeholder={t('onboarding.profile.holder_name')}
                    required
                    type="text"
                    value={this.props.name} />
                </div>
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleLastnameChange}
                    placeholder={t('onboarding.profile.holder_lastname')}
                    required
                    type="text"
                    value={this.props.lastname} />
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-xs-4">
                      <input
                        className="form-control"
                        max="31"
                        min="1"
                        onChange={this.props.handleBirthDay}
                        placeholder={t('onboarding.profile.birth_day')}
                        required
                        type="number"
                        value={this.props.birthDay} />
                    </div>
                    <div className="col-xs-4">
                      <input
                        className="form-control"
                        max="12"
                        min="1"
                        onChange={this.props.handleBirthMonth}
                        placeholder={t('onboarding.profile.birth_month')}
                        required
                        type="number"
                        value={this.props.birthMonth} />
                    </div>
                    <div className="col-xs-4">
                      <input
                        className="form-control"
                        max="2000"
                        min="1900"
                        onChange={this.props.handleBirthYear}
                        placeholder={t('onboarding.profile.birth_year')}
                        required
                        type="number"
                        value={this.props.birthYear} />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handlePhoneChange}
                    placeholder={t('onboarding.profile.holder_phone')}
                    required
                    type="tel"
                    value={this.props.phone} />
                </div>
                <div className="form-group">
                  <label className="radio-inline">
                    <input
                      checked={this.props.gender === GENDER.MALE}
                      name="gender"
                      onChange={this.props.handleGenderChange}
                      type="radio"
                      value={GENDER.MALE} />
                    {t('onboarding.profile.gender_male')}
                  </label>
                  <label className="radio-inline">
                    <input
                      checked={this.props.gender === GENDER.FEMALE}
                      name="gender"
                      onChange={this.props.handleGenderChange}
                      type="radio"
                      value={GENDER.FEMALE} />
                    {t('onboarding.profile.gender_female')}
                  </label>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-block btn-primary btn-singup"
                    type="submit">
                    {t('onboarding.profile.btn_profile')}
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="panel-footer-signup">
            <p className="small signup">
              <Trans i18nKey='onboarding.profile.terms'>
                * Al crear tu cuenta aceptas nuestras&nbsp;
                <a href="https://www.iosoffices.com/terminos-de-uso" rel="noopener noreferrer" target="_blank">condiciones de uso</a>.
              </Trans>
            </p>
            <p className="small signup">
              <Trans i18nKey='onboarding.profile.privacy'>
                Consulta nuestro&nbsp;
                <a href="https://www.iosoffices.com/privacidad" rel="noopener noreferrer" target="_blank">aviso de privacidad</a>.
              </Trans>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Profile);



// WEBPACK FOOTER //
// ./src/onboarding/Profile.js